/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerCallSessionProjection } from './PartnerCallSessionProjection';
import {
    PartnerCallSessionProjectionFromJSON,
    PartnerCallSessionProjectionFromJSONTyped,
    PartnerCallSessionProjectionToJSON,
    PartnerCallSessionProjectionToJSONTyped,
} from './PartnerCallSessionProjection';

/**
 * 
 * @export
 * @interface CallSession
 */
export interface CallSession {
    /**
     * 
     * @type {number}
     * @memberof CallSession
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CallSession
     */
    campaignId: number;
    /**
     * 
     * @type {number}
     * @memberof CallSession
     */
    userId: number;
    /**
     * 
     * @type {PartnerCallSessionProjection}
     * @memberof CallSession
     */
    partnerId: PartnerCallSessionProjection;
    /**
     * 
     * @type {string}
     * @memberof CallSession
     */
    status: string;
}

/**
 * Check if a given object implements the CallSession interface.
 */
export function instanceOfCallSession(value: object): value is CallSession {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('campaignId' in value) || value['campaignId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('partnerId' in value) || value['partnerId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function CallSessionFromJSON(json: any): CallSession {
    return CallSessionFromJSONTyped(json, false);
}

export function CallSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CallSession {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'campaignId': json['campaign_id'],
        'userId': json['user_id'],
        'partnerId': PartnerCallSessionProjectionFromJSON(json['partner_id']),
        'status': json['status'],
    };
}

export function CallSessionToJSON(json: any): CallSession {
    return CallSessionToJSONTyped(json, false);
}

export function CallSessionToJSONTyped(value?: CallSession | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'campaign_id': value['campaignId'],
        'user_id': value['userId'],
        'partner_id': PartnerCallSessionProjectionToJSON(value['partnerId']),
        'status': value['status'],
    };
}

